import loadConstants from 'utils/loads/constants';

import getPalletDimensionsFormatted from 'utils/loads/formatters/getPalletDimensionsFormatted';

const getNumberOfPalletsFormatted = ({
  numberOfPallets,
  palletType,
  loadType,
  length,
  width,
  t,
}) => {
  const { PALLET_TYPES, LOAD_TYPES } = loadConstants;

  const formatterByPalletType = {
    [PALLET_TYPES.EU_PALLET]: 'loads:number_of_pallets.EU_PALLET.default',
    [PALLET_TYPES.US_PALLET]: 'loads:number_of_pallets.US_PALLET.default',
    [PALLET_TYPES.CUSTOM_PALLET]:
      'loads:number_of_pallets.CUSTOM_PALLET.default',
  };

  const formatterByLoadType = {
    [LOAD_TYPES.BULK]: 'loads:number_of_items.BULK.default',
    [LOAD_TYPES.PARCEL]: 'loads:number_of_items.PARCEL.default',
  };

  if (loadType === LOAD_TYPES.BULK) {
    const numberOfItemsFormatted = t(formatterByLoadType[loadType], {
      count: numberOfPallets,
    });

    if (
      length === '' ||
      length === undefined ||
      width === '' ||
      width === undefined
    )
      return `${numberOfItemsFormatted}`;

    const dimensionsOfPalletsFormatted = getPalletDimensionsFormatted({
      length,
      width,
      t,
      format: 'short',
    });

    return `${numberOfItemsFormatted} (${dimensionsOfPalletsFormatted})`;
  }

  if (loadType === LOAD_TYPES.PARCEL) {
    const numberOfItemsFormatted = t(formatterByLoadType[loadType], {
      count: numberOfPallets,
    });

    if (
      length === '' ||
      length === undefined ||
      width === '' ||
      width === undefined
    )
      return `${numberOfItemsFormatted}`;

    const dimensionsOfPalletsFormatted = getPalletDimensionsFormatted({
      length,
      width,
      t,
      format: 'short',
    });

    return `${numberOfItemsFormatted} (${dimensionsOfPalletsFormatted})`;
  }

  if (palletType === PALLET_TYPES.CUSTOM_PALLET) {
    const numberOfPalletsFormatted = t(formatterByPalletType[palletType], {
      count: numberOfPallets,
    });
    if (
      length === '' ||
      length === undefined ||
      width === '' ||
      width === undefined
    )
      return `${numberOfPalletsFormatted}`;

    const dimensionsOfPalletsFormatted = getPalletDimensionsFormatted({
      length,
      width,
      t,
      format: 'short',
    });

    return `${numberOfPalletsFormatted} ${dimensionsOfPalletsFormatted}`;
  }

  return t(formatterByPalletType[palletType], { count: numberOfPallets });
};

export default getNumberOfPalletsFormatted;
